import React from "react";
import { motion } from "framer-motion";
import { Card } from "../components/Card";  // Assuming you have a Card component
import { Link } from "react-router-dom";

const regulatoryBodies = [
  {
    name: "Financial Services Commission (FSC) - Mauritius",
    description:
      "The FSC is the primary regulatory authority in Mauritius, overseeing the financial services sector, including Forex brokers. We assist brokers in meeting the FSC's requirements, including capital adequacy, risk management, and anti-money laundering (AML) regulations.",
    bgColor: "bg-gradient-to-r from-sky-500 ",
  },
  {
    name: "Financial Services Authority (FSA) - Seychelles",
    description:
      "The FSA is responsible for regulating the financial services sector in Seychelles, including Forex brokers. Our team helps brokers comply with the FSA's regulations, including licensing requirements, reporting obligations, and client protection measures.",
    bgColor: "bg-gradient-to-r from-sky-500 ",
  },
  {
    name: "Cyprus Securities and Exchange Commission (CYSEC) - Cyprus",
    description:
      "CYSEC is the primary regulatory authority in Cyprus, overseeing the investment services sector, including Forex brokers. We guide brokers in meeting CYSEC's requirements, including licensing, risk management, and AML regulations.",
    bgColor: "bg-gradient-to-r from-sky-500 ",
  },
  {
    name: "Financial Conduct Authority (FCA) - United Kingdom",
    description:
      "The FCA is one of the most respected regulatory authorities in the world, overseeing the financial services sector in the UK, including Forex brokers. Our team assists brokers in complying with the FCA's regulations, including licensing, reporting, and client protection measures.",
    bgColor: "bg-gradient-to-r from-sky-500 ",
  },
  {
    name: "Financial Service Providers (FSP) - New Zealand",
    description:
      "The FSP is responsible for regulating financial service providers in New Zealand, including Forex brokers. We help brokers meet the FSP's requirements, including registration, reporting, and AML regulations.",
    bgColor: "bg-gradient-to-r from-sky-500 ",
  },
];

export default function ForexRegulations() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 to-indigo-100 flex flex-col items-center p-4 sm:p-6 md:p-10">
      <motion.h1
        className="text-4xl sm:text-5xl font-extrabold text-gray-800 mb-4 sm:mb-6 text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Regulatory Compliance for Forex Brokers
      </motion.h1>
      <p className="text-gray-600 text-center max-w-lg sm:max-w-2xl mb-6 sm:mb-10 text-lg">
        In the ever-evolving world of Forex trading, regulatory compliance is crucial for brokers to operate with transparency, security, and credibility. At Infyst Technologies, we offer expert guidance and support to help Forex brokers navigate the complex regulatory landscape and obtain licenses from reputable authorities worldwide.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-7xl">
        {regulatoryBodies.map((body, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <Card className="p-8 bg-white shadow-xl rounded-2xl text-center flex flex-col items-center transition-transform hover:scale-105 hover:shadow-2xl">
              <h3 className="text-xl sm:text-2xl font-bold mt-4 text-gray-800">{body.name}</h3>
              <p className="text-gray-500 mt-2 text-sm sm:text-base leading-relaxed">{body.description}</p>
            </Card>
          </motion.div>
        ))}
      </div>

      <div className="mt-16 text-center max-w-4xl  bg-white  p-10 rounded-2xl shadow-lg ">
        <h2 className="text-4xl font-bold mb-6 text-black drop-shadow-md">Benefits of Our Regulatory Services</h2>
        <ul className="mt-6 text-gray-600 text-lg space-y-4 sm:space-y-5 list-none">
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Ensure compliance with regulatory requirements
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Enhance reputation and credibility
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Increase investor confidence
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Expand business operations
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Stay up-to-date with regulatory changes
          </li>
        </ul>
      </div>

      <motion.div
        className="mt-12 flex flex-col items-center text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="flex flex-col gap-4 items-center justify-center">
          <Link onClick={() => window.scroll(0, 0)} to="/contact" className="block text-center lg:text-left mt-2 lg:mt-0">
            <button className="bg-sky-500 text-white font-bold px-10 py-3 rounded w-full lg:w-auto">
              Get Started
            </button>
          </Link>
          <p className="text-gray-600 text-lg max-w-2xl mb-6 px-4">
            Ready to get your Forex brokerage licensed? Contact us today and let us help you navigate the regulatory landscape to ensure a smooth journey.
          </p>
        </div>
      </motion.div>
    </div>
  );
}
